import AiSupportedTasksView from "@features/tools/view/ai-supported-tasks-view";

const AiSupportedTasks = () => {
  return <AiSupportedTasksView />;
};

export default AiSupportedTasks;
